/**
 * @flow
 * @relayHash e0dd0c5f2be8b46873e86c3c79a03159
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LoadQueryVariables = {|
  orgId: string,
  type: string,
|};
export type LoadQueryResponse = {|
  +approvalRequests: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +propertyId: string,
        +approved: boolean,
        +propertyName: string,
        +hyevent: ?{|
          +id: string,
          +title: string,
          +publishAt: ?any,
          +status: string,
        |},
        +createdAt: any,
      |}
    |}>
  |}
|};
export type LoadQuery = {|
  variables: LoadQueryVariables,
  response: LoadQueryResponse,
|};
*/


/*
query LoadQuery(
  $orgId: ID!
  $type: String!
) {
  approvalRequests(orgId: $orgId, type: $type) {
    edges {
      node {
        id
        propertyId
        approved
        propertyName
        hyevent {
          id
          title
          publishAt
          status
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalRequests",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "ApprovalRequestConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ApprovalRequestEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ApprovalRequest",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approved",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "hyevent",
                "storageKey": null,
                "args": null,
                "concreteType": "Hyevent",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "publishAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LoadQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LoadQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "LoadQuery",
    "id": null,
    "text": "query LoadQuery(\n  $orgId: ID!\n  $type: String!\n) {\n  approvalRequests(orgId: $orgId, type: $type) {\n    edges {\n      node {\n        id\n        propertyId\n        approved\n        propertyName\n        hyevent {\n          id\n          title\n          publishAt\n          status\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '72cd51113fcf59ea6c960a51f966bff3';
module.exports = node;
